import { render } from "./JournalResultModal.vue?vue&type=template&id=7da19cea&ts=true"
import script from "./JournalResultModal.vue?vue&type=script&lang=ts"
export * from "./JournalResultModal.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__